import api from './api';

const settingsService = {
  // 获取设置
  getSettings: async () => {
    const response = await api.get('/settings');
    return response.data;
  },

  // 保存设置
  saveSettings: async (settings) => {
    const response = await api.post('/settings', settings);
    return response.data;
  }
};

export default settingsService;
